module.exports = __webpack_public_path__ + "static/media/copy.b62833a5.svg";